module.exports = __webpack_public_path__ + "img/category-favorite-hover.f468a433.png";